@if (mostrarNieve) {
  <div class="snow-overlay">
    @for (copo of coposDeNieve; track copo.left) {
      <div
        class="snowflake"
        [style.left.%]="copo.left"
        [style.animation-delay.s]="copo.delay"
        [style.animation-duration.s]="copo.duration"
        [style.width.px]="copo.size"
        [style.height.px]="copo.size"
        [style.fontSize.px]="copo.size"
      >
        <span class="material-icons" style="font-size: inherit">ac_unit</span>
      </div>
    }
  </div>
}
